import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PasteView from './pages/Paste/PasteView.jsx';
import PasteEditor from './pages/Paste/PasteEditor.jsx';

import './hljs-setup';
import './highlight.js';
import "highlight.js/styles/github-dark-dimmed.min.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PasteEditor />} />
        <Route path="/:id" element={<PasteView />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
